"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ObjectId = require('bson').ObjectID;

var History = function History(user, action, collection, documentId, payload) {
  var inventoryId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

  _classCallCheck(this, History);

  this.action = action;
  this.modifiedDate = new Date();
  this.modifiedBy = {
    userId: user.userId,
    firstName: user.firstName,
    lastName: user.lastName
  };
  this.collection = collection;
  this.payload = payload;
  var tempDocId = null;

  try {
    tempDocId = typeof documentId === 'string' ? new ObjectId(documentId) : documentId;
  } catch (e) {
    tempDocId = documentId;
  }

  this.documentId = tempDocId;
  this.inventoryId = inventoryId;
};

module.exports = History;